const steps = [
  {
    no: "01",
    icon: "ri-inbox-archive-line",
    title: "登记与脱敏",
    desc: "收到材料后先登记来源与取得方式，对涉及个人隐私的信息做脱敏处理，再进入求证流程。",
  },
  {
    no: "02",
    icon: "ri-fingerprint-line",
    title: "材料真伪核验",
    desc: "比对文件元数据、画面细节、声音特征与公开记录，判断材料本身是否为原始件。",
  },
  {
    no: "03",
    icon: "ri-node-tree",
    title: "逐条最小事实拆分",
    desc: "把一条爆料拆成可单独验证的最小事实单元，逐条给出成立、不成立或证据不足。",
  },
  {
    no: "04",
    icon: "ri-bar-chart-grouped-line",
    title: "评级与公开",
    desc: "综合来源数量与可复核程度给出可信度评分，标注更新时间，并公开仍在变化的部分。",
  },
];

export default function VerifyProcess() {
  return (
    <section className="border-y border-background-200 bg-foreground-950" aria-labelledby="process-heading">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16">
        <div id="process-heading">
          <div className="mb-10 max-w-2xl">
            <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-accent-400">
              <span className="inline-block h-px w-6 bg-accent-400" aria-hidden="true"></span>
              求证流程
            </p>
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              一条爆料，要经过四道关卡才能给出结论
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-300">
              我们尽量让每一步都留下痕迹，读者看到的不是一个分数，而是一整条可以自行复核的路径。
            </p>
          </div>
        </div>

        <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <li
              key={step.no}
              className="relative flex flex-col rounded-lg border border-background-50/12 bg-background-50/5 p-5 transition-colors hover:border-accent-500/50"
            >
              <span className="font-label text-2xl font-bold text-accent-500/70">{step.no}</span>
              <span className="mt-4 flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                <i className={`${step.icon} text-[20px]`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-background-50">{step.title}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-background-300">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}